import logo from "../assets/logo.png";
import logoMark from "../assets/logo_mark.png";

export const BRAND = {
  name: "Harbor Home Concierge",
  tagline: "We want to give you your time back.",
  positioning: "Personalized home management for busy families.",
  logo,
  logoMark,
};

export const CONTACT = {
  phone: "(978) 886-2817",
  phoneHref: "tel:+19788862817",
  email: "harborhomeconciergeco@gmail.com",
  emailHref: "mailto:harborhomeconciergeco@gmail.com",
  website: "www.harborhomeconciergeco.com",
  instagram: "https://www.instagram.com/harborhome_co",
  facebook: "https://www.facebook.com/share/1UVdtddXD9/?mibextid=wwXIfr",
};

// Placeholder website domain.
export const WEBSITE_URL = "www.harborhomeconciergeco.com";

export const TOWNS = [
  "Hull",
  "Cohasset",
  "Hingham",
  "Scituate",
  "Norwell",
  "Hanover",
  "Duxbury",
  "Marshfield",
];

export const IMAGES = {
  heroLiving:
    "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  livingAlt:
    "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchen:
    "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  laundry:
    "https://images.unsplash.com/photo-1649320101559-acf9dd4c5f5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  pantry:
    "https://images.unsplash.com/photo-1645567454567-901dc409551b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bedroom:
    "https://images.unsplash.com/photo-1770414173168-f6c666501225?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  unpacking:
    "https://images.unsplash.com/photo-1581573950452-5a438c5f390f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  groceries:
    "https://images.unsplash.com/photo-1635108196979-6d2c92b8f81b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  staged:
    "https://images.unsplash.com/photo-1600210492493-0946911123ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  founder:
    "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  propertyMgmt:
    "https://images.unsplash.com/photo-1778603231094-d80e21a66e00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Seven services used across nav dropdown, home band, and pricing table.
export const SERVICES = [
  {
    slug: "weekly-home-concierge",
    path: "/services/weekly-home-concierge",
    title: "Weekly Home Management",
    short: "Weekly Home Management",
    blurb: "A standing weekly relationship that keeps your whole home running.",
    price: "Custom pricing",
    priceNote: "2-hour minimum · weekly · 3-month commitment · monthly billing",
    cta: "Book Your Free Walkthrough",
    ctaType: "book",
    image: IMAGES.kitchen,
  },
  {
    slug: "move-in-concierge",
    path: "/services/move-in-concierge",
    title: "Move-In Concierge",
    short: "Move-In Concierge",
    blurb: "Unpack, organize, and make your new house feel like home from day one.",
    price: "Custom pricing",
    priceNote: "Two-person team · 2-hour minimum",
    cta: "Request a Quote",
    ctaType: "quote",
    image: IMAGES.unpacking,
  },
  {
    slug: "move-out-cleaning",
    path: "/services/move-out-cleaning",
    title: "Move-Out Cleaning Concierge",
    short: "Move-Out Cleaning",
    blurb: "Leave it spotless for the next owners, with a final walkthrough.",
    price: "From $125/hour",
    priceNote: "Quoted by square footage, bedrooms & condition · free estimates",
    cta: "Request a Free Estimate",
    ctaType: "quote",
    image: IMAGES.livingAlt,
  },
  {
    slug: "rental-turnovers",
    path: "/services/rental-turnovers",
    title: "Rental Turnovers",
    short: "Rental Turnovers",
    blurb: "A five-star, guest-ready reset for Airbnb and vacation rentals.",
    price: "Custom quotes",
    priceNote: "Priced per property & turnover frequency",
    cta: "Request a Quote",
    ctaType: "quote",
    image: IMAGES.bedroom,
  },
  {
    slug: "vacation-restocking",
    path: "/services/vacation-restocking",
    title: "Vacation Home Provisions",
    short: "Vacation Provisions",
    blurb: "Arrive and start relaxing — the fridge is full and the flowers are fresh.",
    price: "Custom pricing",
    priceNote: "Shopping billed separately",
    cta: "Request a Quote",
    ctaType: "quote",
    image: IMAGES.groceries,
  },
  {
    slug: "realtor-services",
    path: "/services/realtor-services",
    title: "Realtor Services",
    short: "Realtor Services",
    blurb: "A behind-the-scenes partner for listings, refreshes, and happy sellers.",
    price: "Custom pricing",
    priceNote: "Built around your listings & closings",
    cta: "Partner With Us",
    ctaType: "quote",
    image: IMAGES.staged,
  },
  {
    slug: "property-management",
    path: "/services/property-management",
    title: "Property Management",
    short: "Property Management",
    blurb: "Peace of mind for your South Shore home while you're away.",
    price: "Inquire for pricing",
    priceNote: "Tailored to your home & schedule",
    cta: "Inquire for Pricing",
    ctaType: "quote",
    image: IMAGES.propertyMgmt,
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);

export const TESTIMONIALS = [
  {
    quote:
      "Having Sarah from Harbor Home in my home each week has been truly incredible. She is reliable, trustworthy, and consistently goes above and beyond. The support she provides makes my week so much easier, and I genuinely look forward to the days she is here.",
    name: "Kristen",
    town: "Hanover",
  },
  {
    quote:
      "If you need help around the house, Sarah of Harbor Home is amazing! Laundry, organizing, tidying up, moving things around — she does it all and does it well. Reliable, hard working, and so easy to have around. My home always feels great after she's been there. Highly recommend!",
    name: "Johanna",
    town: "Scituate",
  },
  {
    quote:
      "Working with Sarah at Harbor Home has been a game changer for me. As a busy (and often overwhelmed) mom, having someone I can trust to step in and take tasks off my plate has made an incredible difference in my day-to-day life. Sarah approaches every request with a positive attitude and genuine willingness to help. No task is too small or too daunting. She is kind, dependable, and exceptionally skilled at everything she does. I didn't realize how much I needed this kind of help. I can't recommend Harbor Home highly enough.",
    name: "Tara",
    town: "Cohasset",
  },
  {
    quote:
      "Having Sarah from Harbor Home has made a huge difference in lowering my stress levels. The mountain of laundry that seemed to grow week to week made life feel chaotic, and my two little girls were practically living out of the clean laundry baskets! Sarah has brought a sense of order to our home and helped tackle the household tasks that always seemed to get pushed aside. Knowing I have someone reliable and proactive to delegate those jobs to each week has freed up both my time and mental load. Sarah is lovely, efficient, and the investment has been absolutely worth it for the peace of mind she has given me.",
    name: "Jessica",
    town: "Hingham",
  },
];

// Instagram reels featured in the homepage slideshow (official embeds).
// Add/replace with any public post or reel permalink.
export const INSTAGRAM_REELS = [
  "https://www.instagram.com/reel/DX3-uP6RVqe/",
  "https://www.instagram.com/reel/DYyACKsxzN8/",
  "https://www.instagram.com/reel/DXIb7JXET4I/",
  "https://www.instagram.com/reel/DZrz1X6xJlp/",
  "https://www.instagram.com/reel/DYf8aBzRnBN/",
];

export const FAQS = [
  {
    q: "Are you insured and bonded?",
    a: "Yes. Harbor Home Concierge is fully insured and bonded. Every member of our team is covered before they ever step inside your home, so you're protected and we're accountable.",
  },
  {
    q: "How does the confidentiality agreement work?",
    a: "We sign a confidentiality agreement with every client. What we see and do in your home stays private. We never discuss your household, and your information is never sold or shared.",
  },
  {
    q: "Do I need to be home?",
    a: "Not at all. Most of our weekly clients are out living their day while we're there. We'll build an entry and communication plan that feels comfortable to you.",
  },
  {
    q: "How do keys and entry work?",
    a: "We can work with a lockbox, smart lock, garage code, or a key handoff — whatever you prefer. Access details are documented securely and shared only with your assigned team.",
  },
  {
    q: "What's the 3-month commitment?",
    a: "Weekly Home Management is a standing relationship, not a one-off clean. The initial 3-month commitment lets us learn your home, build your custom plan, and get into a rhythm that actually gives you time back.",
  },
  {
    q: "How does billing work?",
    a: "Weekly service is billed monthly. Project services (move-in, move-out, turnovers, provisions, realtor) are quoted up front. For provisions, any shopping is billed separately at cost.",
  },
  {
    q: "Which towns do you serve?",
    a: "We serve the South Shore: Cohasset, Hingham, Scituate, Norwell, Hanover, Duxbury, and Marshfield, Massachusetts. Just outside the line? Reach out and we'll see what we can do.",
  },
  {
    q: "Cleaning company vs. concierge — what's the difference?",
    a: "A cleaning company shows up and cleans. A home concierge manages your home. We clean, yes, but we also organize, restock, run errands, handle returns, and take on the small projects that pile up — so your whole home runs smoothly.",
  },
];
